import { defineMessages } from "react-intl";

export default defineMessages({
  noAgreement: {
    id: "orderDescription.noAgreement",
    defaultMessage: "No agreement ?",
  },
  opposePayment: {
    id: "orderDescription.opposePayment",
    defaultMessage: "Oppose to the payment",
  },
  confirm: {
    id: "confirm",
    defaultMessage: "Confirm",
  },
  cancel: {
    id: "cancel",
    defaultMessage: "Cancel",
  },
});
